<div
  class="space-y-4 mb-[30px]"
  [class.p-4]="borderRounded"
  [class.border]="borderRounded"
  [class.border-gray-200]="borderRounded"
  [class.rounded-lg]="borderRounded"
>
  <div
    class="flex flex-wrap"
    [class.md:flex-col]="horizontal"
    [class.md:gap-4]="horizontal"
    [class.md:flex-row]="!horizontal"
    [class.md:gap-16]="!horizontal"
  >
    <!-- Title and Subtitle -->
    <div
      [id]="titleId"
      class="mb-3 md:mb-0 flex flex-wrap md:flex-nowrap gap-3 md:gap-0 justify-between"
      [class]="horizontal ? 'w-full' : 'md:w-1/4'"
    >
      <div class="flex flex-wrap items-center gap-2">
        @if (expandIcon && !expandButtonIsDisabled) {
          <app-nicky-button
            variant="text"
            size="nav-button"
            id="show-more"
            [iconLeft]="'ph ph-caret-down text-lg h-fit w-fit px-1.5 border border-[#E0E4E8] rounded-lg'"
            (click)="toggleExpand.emit()"
          >
          </app-nicky-button>
          <!-- <button (click)="toggleExpand.emit()"
          [disabled]="expandButtonIsDisabled"
          id="show-more-button"
          class="h-fit w-fit px-1.5 border border-[#E0E4E8] rounded-lg"
          >
            <i class="ph ph-caret-down text-lg"></i>
          </button> -->
        }
        <div [class.max-w-[70vw]]="expandIcon" [class.md:max-w-unset]="expandIcon" class="block">
          <h1 class="profile-section-title flex items-center gap-1">
            {{ sectionTitle }}
            @if (showTourIcon) {
              <!-- TODO: consider help-book component -->
              <app-nicky-button variant="text" size="extra-small" (click)="onTour.emit()">
                <mat-icon svgIcon="help-book" id="bookIcon"></mat-icon>
              </app-nicky-button>
            } @else {
              <!-- empty element to make the layout consistent -->
              <span class="hidden md:inline-block w-10 h-9"></span>
            }
          </h1>
          <p class="profile-section-subtitle" [innerHTML]="subtitle"></p>
        </div>
      </div>

      @if (showButton) {
        <app-nicky-button
          [fullWidth]="true"
          class="w-full md:w-fit"
          [variant]="buttonVariant"
          [iconLeft]="buttonIcon"
          (click)="buttonClick.emit()"
          [id]="buttonId"
          [disabled]="modalButtonIsDisabled"
        >
          {{ buttonText | translate }}
        </app-nicky-button>
      }
    </div>

    <!-- Content -->
    <div class="w-full" [class.md:flex-1]="!horizontal">
      <ng-content></ng-content>
    </div>
  </div>
</div>
